export const ERROR_LIST: any = {
    went_wrong: 'Une erreur est survenue. Veuillez réessayer.',
};

export const getErrorMessage = (res: string) => {
    return ERROR_LIST[res] ?? ERROR_LIST['went_wrong'];
};
